export const REFERRAL_STORAGE_KEY = 'dzpbw.referral.v1';
export const REFERRAL_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function normalizeCode(value) {
  if (typeof value !== 'string') return null;

  const code = value.trim().toUpperCase();

  return /^[A-Z0-9]{1,16}$/.test(code) ? code : null;
}

function validCampaignSlug(value) {
  return typeof value === 'string'
    && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
    && value.length <= 100;
}

export function saveReferral(storage, campaignSlug, rawCode, now = Date.now()) {
  const code = normalizeCode(rawCode);

  if (!validCampaignSlug(campaignSlug) || code === null) {
    storage.removeItem(REFERRAL_STORAGE_KEY);
    return false;
  }

  storage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify({
    campaignSlug,
    code,
    expiresAt: now + REFERRAL_TTL_MS,
  }));

  return true;
}

export function loadReferral(storage, now = Date.now()) {
  const raw = storage.getItem(REFERRAL_STORAGE_KEY);

  if (raw === null) return null;

  try {
    const referral = JSON.parse(raw);
    const code = normalizeCode(referral?.code);

    if (
      !validCampaignSlug(referral?.campaignSlug)
      || code === null
      || !Number.isSafeInteger(referral?.expiresAt)
      || referral.expiresAt <= now
    ) {
      storage.removeItem(REFERRAL_STORAGE_KEY);
      return null;
    }

    return {
      campaignSlug: referral.campaignSlug,
      code,
      expiresAt: referral.expiresAt,
    };
  } catch {
    storage.removeItem(REFERRAL_STORAGE_KEY);
    return null;
  }
}

export function clearReferral(storage) {
  storage.removeItem(REFERRAL_STORAGE_KEY);
}

export function isReferralValidationError(error) {
  if (error?.status !== 422 || !Array.isArray(error?.response?.errors)) {
    return false;
  }

  return error.response.errors.some(
    (item) => item?.source?.pointer === '/data/attributes/referralCode'
  );
}

export function referralCodeFromUrl(rawUrl) {
  const url = new URL(rawUrl, 'https://local.invalid');

  return normalizeCode(url.searchParams.get('ref'));
}

export function withoutReferralParameter(rawUrl) {
  const url = new URL(rawUrl, 'https://local.invalid');
  url.searchParams.delete('ref');

  return `${url.pathname}${url.search}${url.hash}`;
}
